import { StyleSheet, Platform } from 'react-native';
import { AdminColors } from '../../../../../Admin/constants/adminColors';
import FontFamily from '../../../../../../constants/fonts';

const isWeb = Platform.OS === 'web';

const styles = StyleSheet.create({
  // ── Inner body ────────────────────────────────────────────────────────
  body: {
    gap: 16,
  },

  // ── Gate banner — lock icon + bold text + description ─────────────────
  // Matches HTML `.people-gate` — no border, just horizontal layout
  gateBanner: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    paddingVertical: 4,
  },
  gateIcon: {
    marginTop: 1,
  },
  gateTextBlock: {
    flex: 1,
    gap: 3,
  },
  gateTitle: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textPrimary,
  },
  gateBody: {
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textSecondary,
    lineHeight: 17,
  },

  // ── Action Type picker ────────────────────────────────────────────────
  stepLabel: {
    fontFamily: FontFamily.medium,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textSecondary,
    marginBottom: 8,
  },
  typePicker: {
    flexDirection: isWeb ? 'row' : 'column',
    gap: 10,
  },
  typeCard: {
    flex: isWeb ? 1 : undefined,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 6,
    padding: 12,
    backgroundColor: AdminColors.bgPage,
  },
  typeCardActive: {
    borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue50,
  },
  typeCardTitle: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textPrimary,
    marginBottom: 2,
  },
  typeCardTitleActive: {
    color: AdminColors.blue700,
  },
  typeCardDesc: {
    fontFamily: FontFamily.regular,
    fontSize: 11,
    color: AdminColors.textSecondary,
  },

  // ── Placeholder when no type selected ─────────────────────────────────
  placeholder: {
    fontFamily: FontFamily.regular,
    fontSize: 13,
    color: AdminColors.textMuted,
    fontStyle: 'italic',
  },

  // ── Recommended chips ────────────────────────────────────────────────
  recommendSection: {
    gap: 4,
  },
  recommendLabel: {
    fontFamily: FontFamily.medium,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textPrimary,
  },
  recommendHint: {
    fontFamily: FontFamily.regular,
    fontSize: 11,
    color: AdminColors.textSecondary,
  },
  chipsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 6,
  },
  chip: {
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 5,
    backgroundColor: AdminColors.bgPage,
  },
  chipActive: {
    borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue50,
  },
  chipObservation: {
    borderColor: AdminColors.tagPurple.text,
    backgroundColor: AdminColors.tagPurple.bg,
  },
  chipObservationActive: {
    borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue50,
  },
  chipText: {
    fontFamily: FontFamily.medium,
    fontSize: isWeb ? 12 : 11,
    color: AdminColors.textPrimary,
  },
  chipTextActive: { color: AdminColors.blue700 },
  chipSubText: {
    fontFamily: FontFamily.regular,
    fontSize: 10,
    color: AdminColors.textSecondary,
    marginTop: 1,
  },

  // ── Form field groups ─────────────────────────────────────────────────
  fieldGroup: {
    gap: 12,
  },
  fieldLabel: {
    fontFamily: FontFamily.medium,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textPrimary,
    marginBottom: 4,
  },
  fieldHint: {
    fontFamily: FontFamily.regular,
    fontSize: 11,
    color: AdminColors.textSecondary,
    marginBottom: 4,
  },
  textInput: {
    height: 42,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 4,
    paddingHorizontal: 8,
    backgroundColor: AdminColors.bgSurface,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
  },
  textInputError: { borderColor: AdminColors.textError },
  textArea: {
    minHeight: isWeb ? 80 : 72,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 4,
    padding: 8,
    backgroundColor: AdminColors.bgSurface,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
    textAlignVertical: 'top',
  },
  textAreaError: { borderColor: AdminColors.textError },
  charHint: {
    fontFamily: FontFamily.regular,
    fontSize: 11,
    color: AdminColors.textError,
    marginTop: 4,
  },
});

export default styles;
